
const loginStore = {}
loginStore.state = {
  token: '',
  finishStatus: false
}
loginStore.getters = {
  loginStatus: state => {
    return state.token !== ''
  }
}
loginStore.mutations = {
  setToken (state, token) {
    console.log('setToken')
    state.token = token
  },
  setFinishStatus (state, status) {
    state.finishStatus = status
  },
  userLogout (state) {
    state.token = ''
    state.finishStatus = false
  }
}

loginStore.actions = {
  userLogoutAction ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('userLogout')
      resolve()
    })
  }
}

export default loginStore



// WEBPACK FOOTER //
// ./src/common/login.store.js